import React, { useState, useEffect } from 'react';
import { useWatch } from 'react-hook-form';
// import PropTypes from 'prop-types';
import RadioInputStyles from './styles';
import { generateRandomString } from '../../../utils/helpers';

const RadioInput = ({
    register,
    fieldName,
    label,
    required,
    options, // [{value: '', label: ''}]
    formState: { errors = {} } = {},
    setValue,
    errorMessage,
    control,
    $styles = '',
}) => {
    const currentValue = useWatch({
        control,
        name: fieldName,
    });

    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        <RadioInputStyles $styles={$styles}>
            <div className="input-container">
                <div className="label__container radio__label">
                    <label className="input-label">
                        <span dangerouslySetInnerHTML={{ __html: label }} />
                        {required && <span className="required-asterisk">*</span>}
                    </label>
                </div>

                <div className="option__container">
                    {options.map((option, i) => {
                        const inputRandomId = isClient
                            ? `${option?.value}-${generateRandomString()}`
                            : null;

                        return (
                            <label
                                className={`option__label ${currentValue === option?.value ? 'active' : ''
                                    }`}
                                htmlFor={inputRandomId}
                                key={`${option?.value}-${i}`}>
                                <input
                                    id={inputRandomId}
                                    value={option?.value}
                                    type="radio"
                                    {...register(fieldName, {
                                        required,
                                    })}
                                />
                                <span className="option__circle" />
                                <span
                                    htmlFor={option?.value}
                                    dangerouslySetInnerHTML={{ __html: option?.label }}
                                />
                            </label>
                        );
                    })}
                </div>
                {errors[fieldName] && <span className="input-error">{errorMessage}</span>}
            </div>
        </RadioInputStyles>
    );
};
export default RadioInput;

// RadioInput.propTypes = {
//     register: PropTypes.func.isRequired,
//     fieldName: PropTypes.string.isRequired,
//     required: PropTypes.bool,
//     formState: PropTypes.object,
//     errorMessage: PropTypes.string,
//     setValue: PropTypes.func.isRequired,
//     options: PropTypes.arrayOf(
//         PropTypes.shape({
//             label: PropTypes.string.isRequired,
//             value: PropTypes.string.isRequired,
//         }),
//     ),
// };
